export const squareFootMinimumAreaFactor = 10

export const getMinimumProjectArea = (discounts = []) => {
  const sizes = discounts
    .map(({ size }) => Number(size))
    .filter((size) => Number.isFinite(size) && size > 0)

  if (!sizes.length) return null

  return Math.min(...sizes)
}

export const getMinimumProjectAreaForUnits = (minimumProjectArea, units) => {
  if (!minimumProjectArea) return null

  return units === "ft"
    ? minimumProjectArea * squareFootMinimumAreaFactor
    : minimumProjectArea
}

export const getProjectArea = ({ active, passive }) =>
  Number(active || 0) + Number(passive || 0)

export const hasMinimumProjectAreaError = (
  { units, product, details },
  minimumProjectArea
) => {
  if (product?.measurement !== "squaremeters" || !minimumProjectArea) {
    return false
  }

  const minimumArea = getMinimumProjectAreaForUnits(minimumProjectArea, units)
  const projectArea = getProjectArea(details)

  return projectArea > 0 && projectArea < minimumArea
}

export const getMinimumAreaErrorMessage = (t, minimumArea, unitLabel) => {
  const key = "calculator.minimum-area-error"
  const translated = t(key)
  const fallback = `Minimum project area is ${minimumArea} ${unitLabel}.`

  if (translated !== key) {
    return translated
      .replace("{{minimum}}", minimumArea)
      .replace("{{units}}", unitLabel)
  }

  return fallback
}

export const getMinimumAreaValidationError = (
  inputs,
  calculator,
  t = (key) => key
) => {
  const minimumProjectArea = getMinimumProjectArea(calculator?.discounts)

  if (!hasMinimumProjectAreaError(inputs, minimumProjectArea)) {
    return null
  }

  const minimumArea = getMinimumProjectAreaForUnits(
    minimumProjectArea,
    inputs.units
  )
  const unitLabel = inputs.units === "ft" ? "ft²" : "m²"

  return getMinimumAreaErrorMessage(t, minimumArea, unitLabel)
}
